/**
 * Centralized data for all keyboard shortcuts in the application
 */

export interface ShortcutInfo {
  keys: string[];
  description: string;
}

export interface ShortcutCategory {
  category: string;
  shortcuts: ShortcutInfo[];
}

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
const modKey = isMac ? 'Cmd' : 'Ctrl';

export const SHORTCUTS_DATA: ShortcutCategory[] = [
  {
    category: 'Navigation',
    shortcuts: [{ keys: ['1-9'], description: 'Navigate menu items' }],
  },
  {
    category: 'Call Controls',
    shortcuts: [
      { keys: ['Space'], description: 'Accept incoming call' },
      { keys: ['D'], description: 'Decline incoming call' },
      { keys: ['M'], description: 'Toggle mute' },
      { keys: ['H'], description: 'Toggle hold' },
      { keys: [modKey, 'H'], description: 'Hang up call' },
    ],
  },
  {
    category: 'Modals',
    shortcuts: [
      { keys: ['D'], description: 'Open Dialer' },
      { keys: ['S'], description: 'Open Settings' },
      { keys: ['L'], description: 'Open Logs' },
      { keys: ['A'], description: 'Open Agents List' },
      { keys: ['Esc'], description: 'Close modal' },
    ],
  },
  {
    category: 'Search',
    shortcuts: [
      { keys: [modKey, 'K'], description: 'Focus search input' },
      { keys: ['Enter'], description: 'Submit search' },
    ],
  },
  {
    category: 'Messaging',
    shortcuts: [{ keys: [modKey, 'Enter'], description: 'Send message (SMS/Email/Note)' }],
  },
  {
    category: 'General',
    shortcuts: [{ keys: ['Shift', '?'], description: 'Show keyboard shortcuts' }],
  },
];
